<template>
  <section
    class="approach section-card approach--desktop"
    aria-labelledby="approach-desktop-heading"
  >
    <div class="approach-header" v-reveal>
      <p class="label">Our Approach</p>
      <h2 id="approach-desktop-heading" class="title title-lg">
        Built for shipping companies,<br />here for their customers
      </h2>
    </div>

    <div class="approach-row" v-reveal>
      <div class="panel panel-image">
        <img
          :src="warehouseImage"
          alt="Warehouse owner reviewing inventory with a tablet"
          class="approach-image approach-image--zoom"
          loading="lazy"
        />
      </div>
      <div class="approach-reasons">
        <div v-for="reason in shippingReasons" :key="reason.icon" class="panel panel-reason">
          <div class="reason-heading">
            <component :is="reason.icon" class="reason-icon" aria-hidden="true" />
            <h3 class="title title-md">
              <template v-if="Array.isArray(reason.title)">{{ reason.title[0] }}<br />
                {{ reason.title[1] }}</template>
              <template v-else>{{ reason.title }}</template>
            </h3>
          </div>
          <p class="subtitle subtitle-reason">{{ reason.description }}</p>
        </div>
      </div>
    </div>

    <div class="approach-row" v-reveal>
      <div class="approach-reasons">
        <div v-for="reason in customerReasons" :key="reason.icon" class="panel panel-reason">
          <div class="reason-heading">
            <component :is="reason.icon" class="reason-icon" aria-hidden="true" />
            <h3 class="title title-md">
              <template v-if="Array.isArray(reason.title)">{{ reason.title[0] }}<br />
                {{ reason.title[1] }}</template>
              <template v-else>{{ reason.title }}</template>
            </h3>
          </div>
          <p class="subtitle subtitle-reason">{{ reason.description }}</p>
        </div>
      </div>
      <div class="panel panel-image">
        <img
          :src="familyPackingImage"
          alt="Two people packing a shipment together"
          class="approach-image approach-image--right"
          loading="lazy"
        />
      </div>
    </div>
  </section>
</template>

<script>
import warehouseImage from '../assets/landing2/Owner_Warehouse.webp';
import familyPackingImage from '../assets/landing2/Family_Packing.webp';
import reveal from '../directives/scrollReveal';
import '../assets/styles/landing-shared.scss';

export default {
  name: 'Landing2ApproachDesktop',
  directives: {
    reveal,
  },
  data() {
    return {
      warehouseImage,
      familyPackingImage,
      shippingReasons: [
        {
          icon: 'b-icon-currency-dollar',
          title: ['Get Paid', 'Faster'],
          description: 'Funds land automatically once a delivery is confirmed.',
        },
        {
          icon: 'b-icon-people',
          title: 'Attract More Customers',
          description: 'Stay visible so new customers come to you.',
        },
        {
          icon: 'b-icon-graph-up',
          title: 'Operate Efficiently',
          description: 'Fewer scheduling conflicts, more accurate planning.',
        },
      ],
      customerReasons: [
        {
          icon: 'b-icon-phone',
          title: 'Easy Online Booking',
          description: 'Book from anywhere, anytime, from your device.',
        },
        {
          icon: 'b-icon-search',
          title: 'Discover Your Options',
          description: 'Compare price, speed, and carrier rating.',
        },
        {
          icon: 'b-icon-geo-alt',
          title: 'Track Everything',
          description: 'Know the moment your package arrives.',
        },
      ],
    };
  },
};
</script>

<style scoped>
.approach {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 6rem 3.75rem;
}

.approach-header {
  margin: 0 0 4rem;
  text-align: center;
}

.approach-row {
  display: flex;
  gap: 1.5rem;
}

.approach-row + .approach-row {
  margin-top: 4rem;
}

.approach-image {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.approach-image--zoom {
  transform: scale(1.0); /* I tried scaling to 1.3 to match figma, has artifacts. */
  transform-origin: center;
}

.approach-image--right {
  object-position: right center;
}

.approach-reasons {
  display: flex;
  flex: 1;
  gap: 1.5rem;
}

.reason-heading {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 1rem;
  max-width: 12rem;
}

.reason-icon {
  flex: 0 0 auto;
  width: 2rem;
  height: 2rem;
  color: var(--color-primary);
}

.subtitle-reason {
  width: 13.5rem;
  margin-top: auto;
  font-size: 1rem;
  line-height: 1.5rem;
  color: var(--color-text-secondary);
}

.panel {
  height: 20rem;
  border-radius: 1.25rem;
  overflow: hidden;
}

.panel-image {
  flex: 0 0 25rem;
  width: 25rem;
  background: #F1F2F6;
}

.panel-reason {
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: 2rem 1.5rem;
  background: var(--color-card-bg);
  overflow: visible;
}

@media (max-width: 1439px) {
  .approach--desktop {
    display: none;
  }
}
</style>
